import type { FeatureRequest, FeatureRequestKey } from '@repo/contracts';

import { apiFetch } from './client';

/**
 * "Request Feature" links. Type-only imports from `@repo/contracts` — see
 * `canvas-personas.ts` for why a runtime value from it breaks in the browser.
 */

export const featureRequestKeys = {
  all: ['feature-requests'] as const,
  /** What the signed-in person has asked for. */
  mine: () => [...featureRequestKeys.all, 'mine'] as const,
};

export function listFeatureRequests(): Promise<FeatureRequest[]> {
  return apiFetch<FeatureRequest[]>('/feature-requests');
}

/** Idempotent: asking twice answers with the first request. */
export function requestFeature(payload: {
  feature: FeatureRequestKey;
  projectId?: string;
}): Promise<FeatureRequest> {
  return apiFetch<FeatureRequest>('/feature-requests', {
    body: JSON.stringify(payload),
    method: 'POST',
  });
}
